import React from 'react';

export const SignOutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.1 17C12.4866 17 12.8 16.6866 12.8 16.3C12.8 15.9134 12.4866 15.6 12.1 15.6H6.26667C5.23573 15.6 4.4 14.7643 4.4 13.7333V6.26667C4.4 5.23573 5.23573 4.4 6.26667 4.4H12.1C12.4866 4.4 12.8 4.0866 12.8 3.7C12.8 3.3134 12.4866 3 12.1 3H6.26667C4.46253 3 3 4.46253 3 6.26667V13.7333C3 15.5375 4.46253 17 6.26667 17H12.1ZM13.0252 6.45231C13.3093 6.19009 13.7521 6.2078 14.0144 6.49187L16.8144 9.5252C17.0619 9.79335 17.0619 10.2066 16.8144 10.4748L14.0144 13.5081C13.7521 13.7922 13.3093 13.81 13.0252 13.5477C12.7411 13.2855 12.7234 12.8427 12.9856 12.5585L14.7012 10.7H7.43333C7.04674 10.7 6.73333 10.3866 6.73333 10C6.73333 9.6134 7.04674 9.3 7.43333 9.3H14.7012L12.9856 7.44146C12.7234 7.15739 12.7411 6.71453 13.0252 6.45231Z"
      fill="#27B0E0"
    />
  </svg>
);
